import { createSelector } from "reselect";

import { Immunisation, AppState } from "./model";

export const routeIdSelector = (state: AppState) => {
    return state.router.params.immunisationId;
};

const immunisationsSelector = (state: AppState) => state.immunisations;

export const employeeImmunisationsSelector = createSelector(
    immunisationsSelector,
    (state: AppState) => state.router.params.employeeRecordId,
    (immunisations: Immunisation[], employeeRecordId: string) => {
        return immunisations.filter(t => t.employeeRecordId === employeeRecordId);
    }
);

export const immunisationSelector = createSelector(
    immunisationsSelector,
    routeIdSelector,
    (immunisations: Immunisation[], id: string) => {
        return immunisations.find(t => t.id === id);
    }
);

export const basePathSelector = (state: AppState) => {
    const routeName = "immunisations";
    return state.router.pathname.substring(0, state.router.pathname.indexOf(routeName) + routeName.length);
};
